import { createLucideIcon } from 'lucide-react';
export const Configuration = createLucideIcon('foobar', [
  [
    'path',
    {
      d: 'M10.4146 6.30769L9.0001 5.38462',
      key: 'oti8ue',
    },
  ],
  [
    'path',
    {
      d: 'M10.4146 8.84615L9.0001 9.53846',
      key: '196ngd',
    },
  ],
  [
    'path',
    {
      d: 'M12.2606 4V5.38462',
      key: '1hoyva',
    },
  ],
  [
    'path',
    {
      d: 'M12.2606 9.53846V10.9231',
      key: 'xnyyar',
    },
  ],
  [
    'path',
    {
      d: 'M12.2608 9.53849C13.4078 9.53849 14.3377 8.60862 14.3377 7.46157C14.3377 6.31451 13.4078 5.38464 12.2608 5.38464C11.1137 5.38464 10.1838 6.31451 10.1838 7.46157C10.1838 8.60862 11.1137 9.53849 12.2608 9.53849Z',
      key: '8uh5gs',
    },
  ],
  [
    'path',
    {
      d: 'M14.025 6.30769L15.5006 5.38462',
      key: 'q0rz3h',
    },
  ],
  [
    'path',
    {
      d: 'M14.025 8.84615L15.5006 9.68364',
      key: '4es91q',
    },
  ],
  [
    'path',
    {
      d: 'M16.4146 14.3077L15.0001 13.3846',
      key: 'k73ewj',
    },
  ],
  [
    'path',
    {
      d: 'M16.4146 16.8462L15.0001 17.5385',
      key: '1dfzsp',
    },
  ],
  [
    'path',
    {
      d: 'M18.2606 12V13.3846',
      key: '1sdp5m',
    },
  ],
  [
    'path',
    {
      d: 'M18.2606 17.5385V18.9231',
      key: '4pc64p',
    },
  ],
  [
    'path',
    {
      d: 'M18.2608 17.5385C19.4078 17.5385 20.3377 16.6086 20.3377 15.4616C20.3377 14.3145 19.4078 13.3846 18.2608 13.3846C17.1137 13.3846 16.1838 14.3145 16.1838 15.4616C16.1838 16.6086 17.1137 17.5385 18.2608 17.5385Z',
      key: 'zn1co4',
    },
  ],
  [
    'path',
    {
      d: 'M20.025 14.3077L21.5006 13.3846',
      key: '17ev3u',
    },
  ],
  [
    'path',
    {
      d: 'M20.025 16.8462L21.5006 17.6836',
      key: 'yuqmdo',
    },
  ],
  [
    'path',
    {
      d: 'M4.41458 14.3077L3.0001 13.3846',
      key: '11z2a2',
    },
  ],
  [
    'path',
    {
      d: 'M4.41458 16.8462L3.0001 17.5385',
      key: '18s4v5',
    },
  ],
  [
    'path',
    {
      d: 'M6.26062 12V13.3846',
      key: '1nnsh9',
    },
  ],
  [
    'path',
    {
      d: 'M6.26062 17.5385V18.9231',
      key: '1xnuul',
    },
  ],
  [
    'path',
    {
      d: 'M6.26076 17.5385C7.40781 17.5385 8.33768 16.6086 8.33768 15.4616C8.33768 14.3145 7.40781 13.3846 6.26076 13.3846C5.11371 13.3846 4.18384 14.3145 4.18384 15.4616C4.18384 16.6086 5.11371 17.5385 6.26076 17.5385Z',
      key: 'tsqajq',
    },
  ],
  [
    'path',
    {
      d: 'M8.02499 14.3077L9.50065 13.3846',
      key: '60t5h3',
    },
  ],
  [
    'path',
    {
      d: 'M8.02499 16.8462L9.50065 17.6836',
      key: '1krmae',
    },
  ],
]);
